export default {
  getAnalisiMercatoPercentage(state) {
    let completedFields = 0;
    let fieldCount = 0;
    for (const key in state.analisiMercato.fields) {
      fieldCount++;
      if (
        state.analisiMercato.fields[key] &&
        state.analisiMercato.fields[key] != ""
      ) {
        completedFields++;
      }
    }
    return parseInt((completedFields / fieldCount) * 100);
  },
  getLocalePercentage(state) {
    if (state.locale.saveCounts <= 1) {
      return 0;
    }
    if (state.locale.saveCounts <= 2) {
      return 20;
    }
    if (state.locale.saveCounts <= 3) {
      return 40;
    }
    return 100;
  },
  getMenuPercentage(state) {
    if (state.menu.saveCounts <= 1) {
      return 0;
    }
    if (state.menu.saveCounts <= 2) {
      return 20;
    }
    if (state.menu.saveCounts <= 3) {
      return 80;
    }
    return 100;
  },
  getAnalisiPercentage(state) {
    const completedSteps = Math.min(state.analisi.saveCounts, 6);
    return parseInt(((completedSteps - 1) / 5) * 100);
  },
  getAdempimentiBurocraticiPercentage(state) {
    let count = 0;
    let checked = 0;

    for (const prop in state.adempimentiBurocratici.fields) {
      if (Object.hasOwn(state.adempimentiBurocratici.fields, prop)) {
        count++;
        if (state.adempimentiBurocratici.fields[prop]) {
          checked++;
        }
      }
    }

    return parseInt((checked / count) * 100);
  },
};
